module.exports = __webpack_public_path__ + "static/media/ic_setting.539531cf.png";